import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncParishDetails({ ...rest }) {
  const AsyncLoad = loadable(() => import("../parishDetailsPage"));
  console.log("Loading", AsyncParishDetails.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncParishDetails;
